import { FunctionComponent } from 'react';

import ThemeWrap from '../ThemeWrap';
import Graph from './Graph';

const ThemeWrappedGraph: FunctionComponent = () => <ThemeWrap><Graph /></ThemeWrap>;

export default ThemeWrappedGraph;
